//Skills
import SkillImg1 from "./assets/img/skills/angular.png";
import SkillImg2 from "./assets/img/skills/aws.png";
import SkillImg3 from "./assets/img/skills/azure.png";
import SkillImg4 from "./assets/img/skills/codeigniter.png";
import SkillImg5 from "./assets/img/skills/html5.png";
import SkillImg6 from "./assets/img/skills/jquery.png";
import SkillImg7 from "./assets/img/skills/linux.png";
import SkillImg8 from "./assets/img/skills/mongodb.png";
import SkillImg9 from "./assets/img/skills/nodejs.png";
import SkillImg10 from "./assets/img/skills/postman.png";
import SkillImg11 from "./assets/img/skills/reactjs.png";
import SkillImg12 from "./assets/img/skills/tailwind.png";
import SkillImg13 from "./assets/img/skills/visualStudioCode.png";
import SkillImg14 from "./assets/img/skills/netlify.png";
import SkillImg15 from "./assets/img/skills/php.png";
import SkillImg16 from "./assets/img/skills/bootstrap.png";
import SkillImg17 from "./assets/img/skills/js.png";
import SkillImg18 from "./assets/img/skills/css3.png";
import SkillImg19 from "./assets/img/skills/git.png";
import SkillImg20 from "./assets/img/skills/github.png";
import SkillImg21 from "./assets/img/skills/mysql.png";
import SkillImg22 from "./assets/img/skills/docker.png";

//Projects
import Project1 from "./assets/img/projects/LaboratoriosChela.png";
import Project2 from "./assets/img/projects/coppel.png";
import Project3 from "./assets/img/projects/tucLogo.png";
import Project4 from "./assets/img/projects/hyundai.png";
import Project5 from "./assets/img/projects/CommunityBox.png";
import Project6 from "./assets/img/projects/biotaLogo.png";

export const skills = [
  {
    image: SkillImg1,
    title: "Angular",
  },
  {
    image: SkillImg2,
    title: "Amazon Web Services",
  },
  {
    image: SkillImg3,
    title: "Azure",
  },
  {
    image: SkillImg4,
    title: "Codeigniter 3",
  },
  {
    image: SkillImg5,
    title: "Html 5",
  },
  {
    image: SkillImg6,
    title: "JQuery",
  },
  {
    image: SkillImg7,
    title: "Linux",
  },
  {
    image: SkillImg8,
    title: "Mongo DB",
  },
  {
    image: SkillImg9,
    title: "Node JS",
  },
  {
    image: SkillImg10,
    title: "Postman",
  },
  {
    image: SkillImg11,
    title: "React/ React Native",
  },
  {
    image: SkillImg12,
    title: "Tailwind CSS",
  },
  {
    image: SkillImg13,
    title: "Visual Studio Code",
  },
  {
    image: SkillImg14,
    title: "Netlify",
  },
  {
    image: SkillImg15,
    title: "PHP",
  },
  {
    image: SkillImg16,
    title: "Bootstrap",
  },
  {
    image: SkillImg17,
    title: "JavaScript",
  },
  {
    image: SkillImg18,
    title: "CSS 3",
  },
  {
    image: SkillImg19,
    title: "Git",
  },
  {
    image: SkillImg20,
    title: "GitHub",
  },
  {
    image: SkillImg21,
    title: "MySQL",
  },
  {
    image: SkillImg22,
    title: "Docker",
  },
];

export const projects = [
  {
    image: Project1,
    title: "Laboratorios Chela",
  },
  {
    image: Project2,
    title: "Coppel",
  },
  {
    image: Project3,
    title: "Transportes Unidos del Centro",
  },
  {
    image: Project4,
    title: "Hyundai Motors México",
  },
  {
    image: Project5,
    title: "Community Box",
  },
  {
    image: Project6,
    title: "Viveros Biota",
  },
];
